import { IconProps } from '../icon';

export function ParametreIcon(props: IconProps) {
  return (
    <svg
      id="Paramètre"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="39.989"
      viewBox="0 0 40 39.989"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_322"
            data-name="Rectangle 322"
            width="40"
            height="39.989"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-3">
          <rect
            id="Rectangle_318"
            data-name="Rectangle 318"
            width="20.017"
            height="39.975"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-4">
          <rect
            id="Rectangle_319"
            data-name="Rectangle 319"
            width="20.003"
            height="39.986"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-5">
          <rect
            id="Rectangle_320"
            data-name="Rectangle 320"
            width="11.16"
            height="20.959"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_598" data-name="Groupe 598" clipPath="url(#clipPath)">
        <g id="Groupe_597" data-name="Groupe 597">
          <g id="Groupe_596" data-name="Groupe 596" clipPath="url(#clipPath)">
            <g
              id="Groupe_589"
              data-name="Groupe 589"
              transform="translate(19.983)"
              opacity="0.5"
            >
              <g id="Groupe_588" data-name="Groupe 588">
                <g
                  id="Groupe_587"
                  data-name="Groupe 587"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_239"
                    data-name="Tracé 239"
                    d="M286.975.029c.13-.007.26-.024.389-.021,2.243.056,1.672-.434,2.082,1.875.223,1.256.708,2,1.806,2.267a2.357,2.357,0,0,0,2.583-1.01c1.149-1.494,1.167-1.489,2.8-.561.7.4,1.665.673,1.987,1.28.313.591-.42,1.414-.63,2.156a2.261,2.261,0,0,0,.553,2.371,2.22,2.22,0,0,0,2.363.577c.224-.066.444-.146.663-.226,1.542-.562,1.543-.562,2.363.811.146.245.288.494.427.743.925,1.659.925,1.659-.587,2.864a2.355,2.355,0,0,0,.362,4.128,6.76,6.76,0,0,0,1.9.353c.708.056.976.332.922,1.066a22.35,22.35,0,0,0,0,2.806c.029.552-.211.737-.693.79-.464.051-.925.127-1.387.188a2.37,2.37,0,0,0-1.283,4.186c.256.22.523.427.785.641,1.037.846,1.02.51.335,1.769-.422.775-.911,1.514-1.329,2.291-.185.344-.379.433-.732.283-.454-.192-.922-.35-1.381-.53a2.361,2.361,0,0,0-3.18,3.129.759.759,0,0,1,.029.072c.17.618.773,1.267.515,1.8-.228.472-.992.689-1.526,1.007-.469.279-.97.509-1.416.818-.482.334-.821.293-1.147-.2a12.761,12.761,0,0,0-.818-1.041,2.314,2.314,0,0,0-2.559-.865,2.384,2.384,0,0,0-1.716,2.091c-.437,2.47.275,2.006-2.483,2.01q-.01-4.741-.019-9.483a9.794,9.794,0,0,0,7.257-2.836,10.181,10.181,0,0,0,3.24-7.717,10.1,10.1,0,0,0-3.13-7.448,9.807,9.807,0,0,0-7.368-2.946q.01-4.742.02-9.483"
                    transform="translate(-286.955 0)"
                    fill="#8eac12"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_592"
              data-name="Groupe 592"
              transform="translate(0 0.003)"
              opacity="0.3"
            >
              <g id="Groupe_591" data-name="Groupe 591">
                <g
                  id="Groupe_590"
                  data-name="Groupe 590"
                  clipPath="url(#clipPath-4)"
                >
                  <path
                    id="Tracé_240"
                    data-name="Tracé 240"
                    d="M19.984,30.5q.01,4.742.02,9.483a12.536,12.536,0,0,0-1.4.032c-.649.084-.883-.225-.935-.808-.042-.464-.1-.928-.179-1.387a2.374,2.374,0,0,0-4.152-1.2A10.143,10.143,0,0,0,12.4,37.77c-.3.461-.572.573-1.066.258-.831-.531-1.69-1.022-2.561-1.485a.71.71,0,0,1-.35-1.078,12.744,12.744,0,0,0,.562-1.535,2.2,2.2,0,0,0-.559-2.3,2.2,2.2,0,0,0-2.362-.581c-.545.168-1.082.369-1.61.584-.4.161-.673.14-.9-.278-.526-.956-1.079-1.9-1.641-2.832a.506.506,0,0,1,.179-.781c.418-.307.816-.641,1.219-.969a2.277,2.277,0,0,0,.843-2.5,2.265,2.265,0,0,0-2.058-1.747c-.205-.028-.409-.065-.612-.1C.018,22.137.018,22.136.018,20.613c0-.7.042-1.408-.013-2.106-.044-.562.235-.734.7-.794.488-.062.978-.115,1.464-.193a2.257,2.257,0,0,0,1.982-1.737,2.274,2.274,0,0,0-.783-2.452,5.711,5.711,0,0,0-.906-.734c-.761-.415-.753-.887-.3-1.551.5-.727.922-1.507,1.345-2.281a.64.64,0,0,1,.946-.348A15.775,15.775,0,0,0,6.064,9a2.2,2.2,0,0,0,2.362-.58,2.212,2.212,0,0,0,.561-2.3c-.113-.4-.271-.786-.423-1.172-.427-1.081-.429-1.079.545-1.637.721-.413,1.455-.808,2.158-1.25.477-.3.81-.328,1.137.218a8.4,8.4,0,0,0,.931,1.148,2.254,2.254,0,0,0,2.461.737,2.269,2.269,0,0,0,1.692-1.936c.028-.153.017-.312.044-.465C17.84.027,17.841.027,19.614.049c.13,0,.259.014.389.021q-.01,4.742-.02,9.483v0c-5.695-.246-10.5,4.927-10.514,10.432-.019,5.59,4.837,10.76,10.514,10.51Z"
                    transform="translate(0 -0.045)"
                    fill="#8eac12"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_241"
              data-name="Tracé 241"
              d="M286.878,136.538a9.808,9.808,0,0,1,7.368,2.946,10.619,10.619,0,0,1-.11,15.166,9.794,9.794,0,0,1-7.257,2.836v0c0-1.246.047-2.494,0-3.738a.769.769,0,0,1,.65-.924,5.847,5.847,0,0,0,0-11.619.769.769,0,0,1-.65-.924c.051-1.244.009-2.492,0-3.738v0"
              transform="translate(-266.895 -127.026)"
              fill="#8eac12"
            />
            <g
              id="Groupe_595"
              data-name="Groupe 595"
              transform="translate(9.469 9.506)"
              opacity="0.7"
            >
              <g id="Groupe_594" data-name="Groupe 594">
                <g
                  id="Groupe_593"
                  data-name="Groupe 593"
                  clipPath="url(#clipPath-5)"
                >
                  <path
                    id="Tracé_242"
                    data-name="Tracé 242"
                    d="M146.49,136.513c0,1.246.047,2.494,0,3.738a.769.769,0,0,0,.65.924c-.207,0-.415.012-.622.008a5.418,5.418,0,0,0-5.143,3.044,5.483,5.483,0,0,0,.231,5.917,5.7,5.7,0,0,0,5.534,2.65.769.769,0,0,0-.65.924c.051,1.244.009,2.492,0,3.738-5.677.249-10.534-4.92-10.514-10.51.019-5.505,4.819-10.678,10.514-10.432"
                    transform="translate(-135.976 -136.505)"
                    fill="#8eac12"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ParametreIcon;
